import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {Button, ButtonGroup, Card, Col, Row} from 'react-bootstrap';
import { getApiType } from 'dmpconnectjsapp-base/helpers/accessors';
import {API_TYPES, apiSections} from 'dmpconnectjsapp-base/constants';
import { esLoginTypes } from 'dmpconnectjsapp-base/reducers/dmpconnectESConfiguration';
import {
  getAction,
  logout,
  setLoginStepTwo,
} from '../dmpconnect/actions';
import { isLoading } from 'dmpconnectjsapp-base/helpers/common';
import CenteredCard from '../components/Common/Card/CenteredCard';
import { getActiveReadersCount } from '../dmpconnect/helpers/readers';
import userManager from '../dmpconnect/constants/userManager';
import commands from "dmpconnectjsapp-base/actions/config/commands";
import env from "../envVariables";
import Container from "react-bootstrap/Container";
import lazyWithRetry from "../lib/lazyWithRetry";
import {clearSection, initApplication, setGlobalConfiguration} from "dmpconnectjsapp-base/actions";
import CenteredLoading from "../components/Common/Loading/CenteredLoading";
import Alert from "react-bootstrap/Alert";

const ESJWTLogin = lazyWithRetry(() => import('../components/DMPLogin/ESJWTLogin'));
const ESAPILogin = lazyWithRetry(() => import('../components/DMPLogin/ESAPILogin'));
const ESLogin = lazyWithRetry(() => import('../components/DMPLogin/ESLogin'));
const ESLoginOpenIdConnect = lazyWithRetry(() => import('../components/DMPLogin/ESLoginOpenIdConnect'));
const CPxLogin = lazyWithRetry(() => import('../components/DMPLogin/CPxLogin'));


const loginTabs = {
  cpx: 'cpx',
  es: 'es',
};

class DMPAccess extends Component {
  constructor(props) {
    super(props);
    const { apiType } = props;
    let activeTab = loginTabs.es;

    if (env.REACT_APP_API_TYPE === API_TYPES.REST && [API_TYPES.WS, API_TYPES.JSPOST].includes(apiType)) {
      activeTab = loginTabs.cpx;
    }

    this.state = {
      activeTab,
    };
  }

  componentDidMount() {
    // to keep the session open if we are on the login page
    const { dispatch, loggedIn, cpxLoginType, userToken, apiType, loginTab, cpxLoginActive, requestESLogout } = this.props;
    const { activeTab } = this.state;

    userManager.dispatch = dispatch;
    userManager.loggedIn = userToken ? loggedIn : false;
    userManager.cpxLogin = [API_TYPES.WS, API_TYPES.JSPOST].includes(apiType) && cpxLoginType === 'OPENID';
    if(loggedIn && userToken && !userManager.user) {
      userManager.setUserAndRenew({token: userToken}).then();
    }
    if (requestESLogout === true) {
      userManager.requestSignout();
    }

    if (!loggedIn) {
      this.interval = setInterval(() => {
        dispatch(getAction(
            commands.getSessionState,
            apiSections.SESSION_STATE_SECTION,
            null,
            { synchronous: true },
        ));
      }, Number(env.REACT_APP_SESSION_TIMEOUT - 10) * 1000);


      if(loginTab && loginTab !== activeTab && cpxLoginActive) {
        this.handleModeSwitch(loginTab);
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { requestESLogout: prevRequestEsLogout } = prevProps;
    const { requestESLogout, loggedIn } = this.props;

    if (loggedIn) {
      clearInterval(this.interval);
    }

    if (prevRequestEsLogout === false && requestESLogout === true) {
      userManager.requestSignout();
      this.handleUserLoggedOut();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleUserLoggedOut() {
    const { dispatch } = this.props;
    dispatch(logout());
  }

  handleModeSwitch(mode) {
    const {apiType, dispatch} = this.props;

    if (env.REACT_APP_API_TYPE === API_TYPES.REST) {
      if (mode === loginTabs.cpx && apiType !== API_TYPES.WS) {
        dispatch(setGlobalConfiguration('apiType', API_TYPES.WS));
        dispatch(setGlobalConfiguration('tlsiServerName', Number(env.REACT_APP_PRODUCTON_MODE) === 1
            ? 'https://services-ps.ameli.fr/lps'
            : 'https://qualiflps.services-ps.ameli.fr'
        ));
      } else if (mode === loginTabs.es && apiType !== API_TYPES.REST) {
        dispatch(setGlobalConfiguration('apiType', API_TYPES.REST));
        dispatch(setGlobalConfiguration('tlsiServerName', Number(env.REACT_APP_PRODUCTON_MODE) === 1
            ? 'https://services-ps-tlsm.ameli.fr'
            : 'https://qualiflps-services-ps-tlsm.ameli.fr'
        ));
      }
      dispatch(initApplication());
    } else {
      this.setState({ activeTab: mode });
    }
  }

  goBackToStepOne() {
    const { dispatch } = this.props;
    dispatch(clearSection(apiSections.CPX_CARD_SECTION));
    dispatch(setLoginStepTwo(false));
  }

  render() {
    const {
      esLoginActive,
      esCertificate,
      es_id,
      pcscReaders,
      loggedIn,
      children,
      apiType,
      loginType,
      logoutPending,
      cpxLoginActive,
      cpxLoginType,
      cpxLoginToken,
      expiredSession,
      removedCPX,
      loginStepTwo,
      isFirstLogin,
    } = this.props;
    const { activeTab } = this.state;

    const esActive =
        apiType === API_TYPES.REST
        || env.REACT_APP_API_TYPE === API_TYPES.REST
        || (
            esLoginActive === true
            && (es_id && es_id !== '')
            && (
                loginType === esLoginTypes.CONNECTOR_LOGIN_PASSWD
                || apiType === API_TYPES.REST
                || env.REACT_APP_API_TYPE === API_TYPES.REST
                || (esCertificate && esCertificate !== '')
            )
        );

    const readersLoading = isLoading(pcscReaders);
    const activeReaders = getActiveReadersCount(pcscReaders.Readers) > 0;

    if (logoutPending === true){
      return (
          <>
            <CenteredCard><CenteredLoading message="Déconnexion en cours ..." /></CenteredCard>
          </>
      );
    }
    if (loggedIn === true) {
      return children;
    }

    let title = 'Connexion';
    if (loginStepTwo) {
      title = 'Situation d\'exercice';
    } else if (isFirstLogin === true) {
      title = 'Première connexion'
    }


    return (
        <Suspense fallback={
          <CenteredCard><CenteredLoading message="Chargement ..." /></CenteredCard>
        }>
          {readersLoading ? (
              <CenteredCard><CenteredLoading message="Chargement ..." /></CenteredCard>
          ) : (
              <Container fluid="lg" className="content-wrapper">
                <div className="centered-container">
                  <Card>
                    <Card.Header className="d-flex justify-content-between align-items-center">
                      {title}
                      {loginStepTwo ? (
                          <Button
                              size="xs"
                              variant="outline-secondary"
                              onClick={() => this.goBackToStepOne()}
                          >
                            <i className="ic-back" />
                            Retour
                          </Button>
                      ) : (
                          <>
                            {esActive && (activeReaders || apiType === API_TYPES.REST || env.REACT_APP_API_TYPE === API_TYPES.REST) && cpxLoginActive === true && (
                                <ButtonGroup className="float-right ml-3">
                                  <Button
                                      size="xs"
                                      variant="outline-secondary"
                                      onClick={() => this.handleModeSwitch(loginTabs.cpx)}
                                      active={activeTab === loginTabs.cpx}
                                  >
                                    CPx
                                  </Button>
                                  <Button
                                      size="xs"
                                      variant="outline-secondary"
                                      onClick={() => this.handleModeSwitch(loginTabs.es)}
                                      active={activeTab === loginTabs.es}
                                  >
                                    ES
                                  </Button>
                                </ButtonGroup>
                            )}
                          </>
                      )}
                    </Card.Header>
                    <Card.Body>
                      <Row className="align-items-center justify-content-center">
                        <Col sm="auto">
                          <Card.Img variant="top" src="/images/logo/INSI-CONSULT-VERT.png" className="loginLogo" />
                        </Col>
                        <Col sm="auto">

                            {expiredSession && (
                                <Alert variant="danger">
                                  La session a expiré.
                                </Alert>
                            )}
                            {removedCPX && (
                                <Alert variant="danger">
                                  La carte CPS a été retirée.
                                </Alert>
                            )}
                            {apiType !== API_TYPES.REST && (
                                <>
                                  {((activeReaders && activeTab === loginTabs.cpx) || !esActive) && (
                                      <div id="cpx_login_form">
                                        <CPxLogin userManager={userManager} cpxLoginType={cpxLoginType} cpxLoginToken={cpxLoginToken} />
                                      </div>
                                  )}
                                </>
                            )}
                            {esActive && activeTab === loginTabs.es && (
                                <div id="es_login_form">
                                  {loginType === esLoginTypes.OPENID && (
                                      <ESLoginOpenIdConnect userManager={userManager} />
                                  )}
                                  {loginType === esLoginTypes.TOKEN && (
                                      <ESJWTLogin />
                                  )}
                                  {loginType === esLoginTypes.API && (
                                      <ESAPILogin />
                                  )}
                                  {[esLoginTypes.LOGIN_PASSWD, esLoginTypes.CONNECTOR_LOGIN_PASSWD].includes(
                                      loginType) && (
                                      <ESLogin />
                                  )}
                                </div>
                            )}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              </Container>
          )}
        </Suspense>
    );
  }
}


DMPAccess.propTypes = {
  dispatch: PropTypes.func.isRequired,
  expiredSession: PropTypes.bool,
  removedCPX: PropTypes.bool,
  esLoginActive: PropTypes.bool,
  esCertificate: PropTypes.string,
  pcscReaders: PropTypes.object,
  loggedIn: PropTypes.bool,
  requestESLogout: PropTypes.bool,
  logoutPending: PropTypes.bool,
  cpxLoginActive: PropTypes.bool,
  loginCheckApi: PropTypes.bool,
  children: PropTypes.node.isRequired,
  loginType: PropTypes.string,
  apiType: PropTypes.string.isRequired,
  es_id: PropTypes.string,
  userToken: PropTypes.object,
  cpxLoginToken: PropTypes.string,
  loginStepTwo: PropTypes.bool,
  isFirstLogin: PropTypes.bool,
  loginTab: PropTypes.string,
};

DMPAccess.defaultProps = {
  expiredSession: false,
  removedCPX: false,
  esLoginActive: false,
  esCertificate: '',
  pcscReaders: {},
  loggedIn: false,
  requestESLogout: false,
  logoutPending: false,
  cpxLoginActive: false,
  loginCheckApi: false,
  loginType: null,
  es_id: '',
  userToken: undefined,
  cpxLoginToken: null,
  loginStepTwo: false,
  isFirstLogin: false,
  loginTab: undefined,
};

function mapStateToProps(state) {
  const {
    dmpconnect: {
      [apiSections.PCSC_READERS_SECTION]: pcscReaders,
    },
    dmpconnectESConfiguration: {
      esLoginActive, esCertificate, loginType, es_id, cpxLoginActive, loginCheckApi,
    },
    dmpConnectPersistedAppConfiguration: {
      cpxLoginType,
      cpxLoginToken,
    },
    dmpconnectUser: {
      loggedIn,
      requestESLogout,
      logoutPending,
      userJWT,
      expiredSession,
      removedCPX,
      loginStepTwo,
    },
    dmpconnectApplication: {
      isFirstLogin,
      loginTab,
    }
  } = state;

  return {
    apiType: getApiType(state),
    pcscReaders,
    esLoginActive,
    esCertificate,
    loggedIn,
    requestESLogout,
    loginType: Number(env.REACT_APP_DEBUG) !== 1 && loginType === esLoginTypes.LOGIN_PASSWD
        ? esLoginTypes.OPENID
        : loginType,
    loginCheckApi,
    logoutPending,
    es_id,
    cpxLoginActive,
    cpxLoginType,
    cpxLoginToken,
    userToken: userJWT,
    expiredSession,
    removedCPX,
    loginStepTwo,
    isFirstLogin,
    loginTab,
  };
}

const connectedDMPAccess = connect(mapStateToProps)(DMPAccess);

export default connectedDMPAccess;
